export default __webpack_public_path__ + "static/CyberSecurity-8db07df1edb7fa67bc176b1e34ae9d09.jpeg";